import httpClient from './httpClient';
import * as apis from '../constants/api';

export const postFingerPrint = () => {
  const Fingerprint2 = window.Fingerprint2;
  return new Promise(function (resolve) {
    Fingerprint2.get(function (components) {
      const userAgent =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }).value) ||
        '';
      const webdriver =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'webdriver';
          }) &&
          components.find(function (v) {
            return v.key === 'webdriver';
          }).value) ||
        '';
      const language =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'language';
          }) &&
          components.find(function (v) {
            return v.key === 'language';
          }).value) ||
        '';
      const colorDepth =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'colorDepth';
          }) &&
          components.find(function (v) {
            return v.key === 'colorDepth';
          }).value) ||
        '';
      const deviceMemory =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'deviceMemory';
          }) &&
          components.find(function (v) {
            return v.key === 'deviceMemory';
          }).value) ||
        '';
      const hardwareConcurrency =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hardwareConcurrency';
          }) &&
          components.find(function (v) {
            return v.key === 'hardwareConcurrency';
          }).value) ||
        '';
      let screenResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'screenResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'screenResolution';
          }).value) ||
        '';
      screenResolution = screenResolution.join('x');
      let availableScreenResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'availableScreenResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'availableScreenResolution';
          }).value) ||
        '';
      availableScreenResolution = availableScreenResolution.join('x');
      const timezoneOffset =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'timezoneOffset';
          }) &&
          components.find(function (v) {
            return v.key === 'timezoneOffset';
          }).value) ||
        '';
      const timezone =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'timezone';
          }) &&
          components.find(function (v) {
            return v.key === 'timezone';
          }).value) ||
        '';
      const platform =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'platform';
          }) &&
          components.find(function (v) {
            return v.key === 'platform';
          }).value) ||
        '';
      /* var fonts =
        (components &&
          Array.isArray(components) &&
          components.find(function(v) {
            return v.key === 'fonts';
          }) &&
          components.find(function(v) {
            return v.key === 'fonts';
          }).value) ||
        '';
      fonts = fonts.join(','); */
      const addBehavior =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'addBehavior';
          }) &&
          components.find(function (v) {
            return v.key === 'addBehavior';
          }).value) ||
        '';
      const sessionStorage =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'sessionStorage';
          }) &&
          components.find(function (v) {
            return v.key === 'sessionStorage';
          }).value) ||
        '';
      const localStorage =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'localStorage';
          }) &&
          components.find(function (v) {
            return v.key === 'localStorage';
          }).value) ||
        '';
      const indexedDb =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'indexedDb';
          }) &&
          components.find(function (v) {
            return v.key === 'indexedDb';
          }).value) ||
        '';
      const cpuClass =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'cpuClass';
          }) &&
          components.find(function (v) {
            return v.key === 'cpuClass';
          }).value) ||
        '';
      const webglVendorAndRenderer =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'webglVendorAndRenderer';
          }) &&
          components.find(function (v) {
            return v.key === 'webglVendorAndRenderer';
          }).value) ||
        '';
      const hasLiedLanguages =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hasLiedLanguages';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedLanguages';
          }).value) ||
        '';
      const hasLiedResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hasLiedResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedResolution';
          }).value) ||
        '';
      const hasLiedOs =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedOs';
          }).value) ||
        '';

      const obj = {
        userAgent: userAgent + '',
        webdriver: webdriver + '',
        language: language + '',
        colorDepth: colorDepth + '',
        deviceMemory: deviceMemory + '',
        hardwareConcurrency: hardwareConcurrency + '',
        screenResolution: screenResolution + '',
        availableScreenResolution: availableScreenResolution + '',
        timezoneOffset: timezoneOffset + '',
        timezone: timezone + '',
        platform: platform + '',
        fonts: '',
        addBehavior: addBehavior + '',
        sessionStorage: sessionStorage + '',
        localStorage: localStorage + '',
        indexedDb: indexedDb + '',
        cpuClass: cpuClass + '',
        webglVendorAndRenderer: webglVendorAndRenderer + '',
        hasLiedLanguages: hasLiedLanguages + '',
        hasLiedResolution: hasLiedResolution + '',
        hasLiedOs: hasLiedOs + '',
      };
      httpClient
        .post(apis.POST_FINGERPRINT, {
          fingerMark: obj,
          hashCode: '',
        })
        .then(function () {
          resolve();
        });
    });
  });
};

export const trackingVendor = (vendorId, currentURL, studentId) => {
  const Fingerprint2 = window.Fingerprint2;
  return new Promise(function (resolve) {
    Fingerprint2.get(function (components) {
      const userAgent =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }).value) ||
        '';
      const webdriver =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'webdriver';
          }) &&
          components.find(function (v) {
            return v.key === 'webdriver';
          }).value) ||
        '';
      const language =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'language';
          }) &&
          components.find(function (v) {
            return v.key === 'language';
          }).value) ||
        '';
      const colorDepth =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'colorDepth';
          }) &&
          components.find(function (v) {
            return v.key === 'colorDepth';
          }).value) ||
        '';
      const deviceMemory =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'deviceMemory';
          }) &&
          components.find(function (v) {
            return v.key === 'deviceMemory';
          }).value) ||
        '';
      const hardwareConcurrency =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hardwareConcurrency';
          }) &&
          components.find(function (v) {
            return v.key === 'hardwareConcurrency';
          }).value) ||
        '';
      let screenResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'screenResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'screenResolution';
          }).value) ||
        '';
      screenResolution = screenResolution.join('x');
      let availableScreenResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'availableScreenResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'availableScreenResolution';
          }).value) ||
        '';
      availableScreenResolution = availableScreenResolution.join('x');
      const timezoneOffset =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'timezoneOffset';
          }) &&
          components.find(function (v) {
            return v.key === 'timezoneOffset';
          }).value) ||
        '';
      const timezone =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'timezone';
          }) &&
          components.find(function (v) {
            return v.key === 'timezone';
          }).value) ||
        '';
      const platform =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'platform';
          }) &&
          components.find(function (v) {
            return v.key === 'platform';
          }).value) ||
        '';
      //const fonts =
      //  (components &&
      //    Array.isArray(components) &&
      //    components.find(function (v) {
      //      return v.key === 'fonts';
      //    }) &&
      //    components.find(function (v) {
      //      return v.key === 'fonts';
      //    }).value) ||
      //  '';
      const addBehavior =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'addBehavior';
          }) &&
          components.find(function (v) {
            return v.key === 'addBehavior';
          }).value) ||
        '';
      const sessionStorage =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'sessionStorage';
          }) &&
          components.find(function (v) {
            return v.key === 'sessionStorage';
          }).value) ||
        '';
      const localStorage =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'localStorage';
          }) &&
          components.find(function (v) {
            return v.key === 'localStorage';
          }).value) ||
        '';
      const indexedDb =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'indexedDb';
          }) &&
          components.find(function (v) {
            return v.key === 'indexedDb';
          }).value) ||
        '';
      const cpuClass =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'cpuClass';
          }) &&
          components.find(function (v) {
            return v.key === 'cpuClass';
          }).value) ||
        '';
      const webglVendorAndRenderer =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'webglVendorAndRenderer';
          }) &&
          components.find(function (v) {
            return v.key === 'webglVendorAndRenderer';
          }).value) ||
        '';
      const hasLiedLanguages =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hasLiedLanguages';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedLanguages';
          }).value) ||
        '';
      const hasLiedResolution =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'hasLiedResolution';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedResolution';
          }).value) ||
        '';
      const hasLiedOs =
        (components &&
          Array.isArray(components) &&
          components.find(function (v) {
            return v.key === 'userAgent';
          }) &&
          components.find(function (v) {
            return v.key === 'hasLiedOs';
          }).value) ||
        '';

      const obj = {
        userAgent: userAgent + '',
        webdriver: webdriver + '',
        language: language + '',
        colorDepth: colorDepth + '',
        deviceMemory: deviceMemory + '',
        hardwareConcurrency: hardwareConcurrency + '',
        screenResolution: screenResolution + '',
        availableScreenResolution: availableScreenResolution + '',
        timezoneOffset: timezoneOffset + '',
        timezone: timezone + '',
        platform: platform + '',
        fonts: '',
        addBehavior: addBehavior + '',
        sessionStorage: sessionStorage + '',
        localStorage: localStorage + '',
        indexedDb: indexedDb + '',
        cpuClass: cpuClass + '',
        webglVendorAndRenderer: webglVendorAndRenderer + '',
        hasLiedLanguages: hasLiedLanguages + '',
        hasLiedResolution: hasLiedResolution + '',
        hasLiedOs: hasLiedOs + '',
        deviceThumbprit: currentURL,
        studentId,
      };
      httpClient
        .post(apis.TRACKING_VENDOR_RECORD, {
          fingerMark: obj,
          vendorId,
          studentId,
        })
        .then(function () {
          resolve();
        });
    });
  });
};
